import Row from "./funcs/Row";
import Column from "./funcs/Column";
import Content from "./funcs/Content";
import Copy from "./funcs/Copy";
import Range from "./funcs/Range";
import Style from "./funcs/Style";
import Table from "./funcs/Table";
import Merge from "./funcs/Merge";
import Arrow from "./funcs/Arrow";
import MetaData from "./funcs/MetaData";
import Flow from "./funcs/Flow";
import Fill from "./funcs/Fill";
import Icon from "./funcs/Icon";
import View from "./funcs/View";
import Corner from "./funcs/Corner";

export function funcHelper(dispatch, rootState, rootGetters) {
  let currentSheet = rootState.sheets.currentSheet;
  let currentSheetId = currentSheet.sheetId;
  let currentSheetName = currentSheet.name;
  let current = rootState.cells.current;
  let designId = current.id;

  let context = { dispatch, rootState, rootGetters, currentSheet, currentSheetId, currentSheetName, current, designId }; // Create a context object

  const funcs = {
    setProperties() {
      currentSheet = rootState.sheets.currentSheet;
      currentSheetId = currentSheet.sheetId;
      currentSheetName = currentSheet.name;
      current = rootState.cells.current;
      designId = current.id;
      context = { dispatch, rootState, rootGetters, currentSheet, currentSheetId, currentSheetName, current, designId }; // Create a context object
      this.row = Row(context);
      this.column = Column(context);
      this.content = Content(context);
      this.copy = Copy(context);
      this.range = Range(context);
      this.style = Style(context);
      this.table = Table(context);
      this.merge = Merge(context);
      this.arrow = Arrow(context);
      this.metaData = MetaData(context);
      this.flow = Flow(context);
      this.fill = Fill(context);
      this.icon = Icon(context);
      this.view = View(context);
    },
    row: Row(context),
    column: Column(context),
    content: Content(context),
    copy: Copy(context),
    range: Range(context),
    style: Style(context),
    table: Table(context),
    merge: Merge(context),
    arrow: Arrow(context),
    metaData: MetaData(context),
    flow: Flow(context),
    fill: Fill(context),
    icon: Icon(context),
    view: View(context),
    corner: Corner(context),
  };
  return funcs;
}

export const rangeToHfFormat = (currentSheet, range) => {
  return {
    start: { sheet: currentSheet.sheetId, col: range[0], row: range[1] },
    end: { sheet: currentSheet.sheetId, col: range[2], row: range[3] },
  };
};
